import {
  Heading,
  Stack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  useToast,
} from '@chakra-ui/react'
import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import UsersSearchList from './components/UsersSearchList'
import ExportUsers from './ExportUsers'
import Reports from './Reports'
import UserCounters from './UserCounters'

const tabs = ['#list', '#search', '#counters', '#export', '#reports']

export default function UsersPage() {
  const { hash } = useLocation()
  const navigate = useNavigate()
  const toast = useToast()

  useEffect(() => {
    const adminName = sessionStorage.getItem('postImpersonationAdminName')
    if (!adminName) return

    sessionStorage.removeItem('postImpersonationAdminName')
    toast({
      title: 'Impersonation ended',
      description: `You are now ${adminName}.`,
      status: 'success',
      position: 'top',
      duration: 5000,
      isClosable: true,
    })
  }, [toast])

  return (
    <Stack spacing={5}>
      <Heading>Users</Heading>
      <Tabs
        index={Math.max(tabs.indexOf(hash), 0)}
        onChange={(index) => navigate(tabs[index])}
      >
        <TabList>
          <Tab>List</Tab>
          <Tab>Search</Tab>
          <Tab>Counters</Tab>
          <Tab>Export</Tab>
          <Tab>Reports</Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <UsersSearchList list />
          </TabPanel>
          <TabPanel>
            <UsersSearchList />
          </TabPanel>
          <TabPanel>
            <UserCounters />
          </TabPanel>
          <TabPanel>
            <ExportUsers />
          </TabPanel>
          <TabPanel>
            <Reports />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Stack>
  )
}
